import {
    RESEND_INVITE_OPEN_MODAL,
    RESEND_INVITE_CLOSE_MODAL,
    RESEND_INVITE_REQUEST,
    RESEND_INVITE_RESULT,
} from 'Redux/actionTypes';

export const resendInviteOpenModal = (data) => ({
    type: RESEND_INVITE_OPEN_MODAL,
    payload: data
})

export const resendInviteCloseModal = () => ({
    type: RESEND_INVITE_CLOSE_MODAL
})

export const resendInviteRequest = (data) => ({
    type: RESEND_INVITE_REQUEST,
    payload: data
})

export const resendInviteResult = (result) => ({
    type: RESEND_INVITE_RESULT,
    payload: result
})